import React from "react";
import Layout from "../../components/Layout";
import Buy from "./sections/Buy";
import Ecosystem from "./sections/Ecosystem";
import Hero from "./sections/Hero";
import Join from "./sections/Join";
import Roadmap from "./sections/Roadmap";
import Tax from "./sections/Tax";
import Tokenomics from "./sections/Tokenomics";
import UtilImage from "../../assets/util1.png";
const Home = ({ connectHandler }) => {
  return (
    <div className="relative">
      <Layout connectHandler={connectHandler}>
        <Hero />
        <div className="relative">
          <Ecosystem />
          <img
            src={UtilImage}
            className="absolute sm:block hidden right-0 top-1/2 -translate-y-1/4"
            alt=""
          />
          <Tax />
        </div>
        <Tokenomics />
        <Buy />
        <Roadmap />
        <Join />
      </Layout>
    </div>
  );
};

export default Home;
